import { __decorate } from "tslib";
import { Component, HostListener, ViewChild, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../services/http-client.service';
import { WebClientService } from '../../services/webclient-settings.service';
import { WebsiteThemeService } from '../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
let CryptoAtmsComponent = class CryptoAtmsComponent {
    constructor(httpClient, wcss, sanitizer, themeService) {
        this.httpClient = httpClient;
        this.wcss = wcss;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.atms = [];
        this.lastOpenIndex = -1;
        this.activeTab = 1;
        this.citiesArray = [];
        this.showCities = false;
        this.typesArray = [];
        this.showTypes = false;
        this.showAtms = [];
        this.city = 'all';
        this.type = 'all';
        this.latitude = 44.4419211;
        this.longitude = 20.4830112;
        this.zoom = 7.2;
        this.checkedCity = '';
        this.checkedType = '';
        this.waterColor = '';
        this.mainColor = '';
        this.secondaryColor = '';
        this.successColor = '';
        this.textColor = '';
        this.tabColor = '';
        this.borderRadiusSmaller = '';
        this.styles = {};
        this.clusterStyle = {
            textSize: 32
        };
        this.title = 'ECD maps';
        this.lat = 44.4419211;
        this.lng = 20.4830112;
        this.themeService.getTheme().subscribe((data) => {
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.secondaryColor = this.themeService.getStyleAttribute('secondary_text_color');
            this.successColor = this.themeService.getStyleAttribute('success_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.tabColor = this.themeService.getStyleAttribute('tab_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
        });
    }
    onDocumentClick(event) {
        const targetElement = event.target;
        if (targetElement.className !== 'menu_atm_holder' &&
            targetElement.className !== 'menu_atm_holder2' &&
            targetElement.className !== 'fa fa-caret-down' &&
            targetElement.className !== 'menu_one' &&
            targetElement.className !== 'menu_two') {
            this.closeCities();
            this.closeTypes();
        }
        if (this.showCities &&
            (targetElement.className === 'menu_atm_holder2' ||
                targetElement.className === 'menu_two' ||
                targetElement.id === 'two')) {
            this.closeCities();
        }
        if (this.showTypes &&
            (targetElement.className === 'menu_atm_holder' ||
                targetElement.className === 'menu_one' ||
                targetElement.id === 'one')) {
            this.closeTypes();
        }
    }
    closeTypes() {
        this.showTypes = false;
    }
    closeCities() {
        this.showCities = false;
    }
    ngOnInit() {
        this.setActive(1);
        this.styles = [
            {
                'featureType': 'administrative',
                'elementType': 'labels.text.fill',
                'stylers': [
                    {
                        'color': '#444444'
                    }
                ]
            },
            {
                'featureType': 'landscape',
                'elementType': 'all',
                'stylers': [
                    {
                        'color': '#f2f2f2'
                    }
                ]
            },
            {
                'featureType': 'poi',
                'elementType': 'all',
                'stylers': [
                    {
                        'visibility': 'off'
                    }
                ]
            },
            {
                'featureType': 'road',
                'elementType': 'all',
                'stylers': [
                    {
                        'saturation': -100
                    },
                    {
                        'lightness': 45
                    }
                ]
            },
            {
                'featureType': 'road.highway',
                'elementType': 'all',
                'stylers': [
                    {
                        'visibility': 'simplified'
                    }
                ]
            },
            {
                'featureType': 'road.highway',
                'elementType': 'geometry.fill',
                'stylers': [
                    {
                        'saturation': '-21'
                    },
                    {
                        'gamma': '2.98'
                    },
                    {
                        'weight': '4.77'
                    },
                    {
                        'lightness': '20'
                    }
                ]
            },
            {
                'featureType': 'road.arterial',
                'elementType': 'labels.icon',
                'stylers': [
                    {
                        'visibility': 'off'
                    }
                ]
            },
            {
                'featureType': 'transit',
                'elementType': 'all',
                'stylers': [
                    {
                        'visibility': 'off'
                    }
                ]
            },
            {
                'featureType': 'water',
                'elementType': 'all',
                'stylers': [
                    {
                        'color': '#2a4e6e'
                    },
                    {
                        'visibility': 'on'
                    }
                ]
            }
        ];
        this.themeService.getTheme().subscribe((data) => {
            this.waterColor = this.themeService.getStyleAttribute('map_water_color');
            for (let i = 0; i < this.styles.length; i++) {
                if (this.styles[i].featureType === 'water') {
                    this.styles[i].stylers[0].color = this.waterColor;
                }
            }
        });
    }
    ngAfterViewInit() {
        // this.agmMap.mapReady.subscribe(
        //     map => {
        //         const bounds: LatLngBounds = new google.maps.LatLngBounds();
        //         bounds.extend(new google.maps.LatLng(this.latitude, this.longitude));
        //         map.panToBounds(bounds);
        //     }
        // );
    }
    convertStringToNumber(value) {
        return +value;
    }
    clickedMarker(data, index, type) {
        if (type === 'atm') {
            data['isOpen'] = true;
            if (this.lastOpenIndex > -1) {
                this.atms[this.lastOpenIndex]['isOpen'] = false;
            }
            this.lastOpenIndex = index;
        }
    }
    setActive(tabId) {
        this.checkedCity = '';
        this.checkedType = '';
        this.city = 'all';
        this.type = 'all';
        if (this.activeTab !== tabId) {
            this.activeTab = tabId;
        }
        this.httpClient.get('atms').subscribe((result) => {
            this.atms = result;
            this.showAtms = this.atms;
            let j = 0;
            let k = 0;
            for (let i = 0; i < this.atms.length; i++) {
                if (this.citiesArray.indexOf(this.atms[i].city) === -1) {
                    this.citiesArray[j] = this.atms[i].city;
                    j++;
                }
                if (this.typesArray.indexOf(this.atms[i].atm_type) === -1) {
                    this.typesArray[k] = this.atms[i].atm_type;
                    k++;
                }
            }
        });
    }
    clickCity() {
        this.showCities = !this.showCities;
    }
    clickType() {
        this.showTypes = !this.showTypes;
    }
    chooseCity(city) {
        if (this.agmMap.zoom !== 7.2) {
            const latitude = 44.4419211;
            const longitude = 20.4830112;
            this.agmMap.triggerResize().then((success) => {
                this.agmMap._mapsWrapper.setCenter({ lat: latitude, lng: longitude });
                this.agmMap._mapsWrapper.setZoom(7.2);
            });
        }
        this.city = city;
        this.showAtms = [];
        let j = 0;
        for (let i = 0; i < this.atms.length; i++) {
            this.atms[i]['isOpen'] = false;
            if (city === 'all') {
                if (this.type === 'all') {
                    this.showAtms = this.atms;
                }
                else if (this.atms[i].atm_type === this.type) {
                    this.showAtms[j] = this.atms[i];
                    j++;
                }
            }
            else if (this.atms[i].city === city) {
                if (this.type === 'all') {
                    this.showAtms[j] = this.atms[i];
                    j++;
                }
                else if (this.atms[i].atm_type === this.type) {
                    this.showAtms[j] = this.atms[i];
                    j++;
                }
            }
        }
        this.checkedCity = city;
        this.showCities = false;
    }
    chooseType(type) {
        if (this.agmMap.zoom !== 7.2) {
            const latitude = 44.4419211;
            const longitude = 20.4830112;
            this.agmMap.triggerResize().then((success) => {
                this.agmMap._mapsWrapper.setCenter({ lat: latitude, lng: longitude });
                this.agmMap._mapsWrapper.setZoom(7.2);
            });
        }
        this.type = type;
        this.showAtms = [];
        let j = 0;
        for (let i = 0; i < this.atms.length; i++) {
            this.atms[i]['isOpen'] = false;
            if (type === 'all') {
                if (this.city === 'all') {
                    this.showAtms = this.atms;
                }
                else if (this.atms[i].city === this.city) {
                    this.showAtms[j] = this.atms[i];
                    j++;
                }
            }
            else if (this.atms[i].atm_type === type) {
                if (this.city === 'all') {
                    this.showAtms[j] = this.atms[i];
                    j++;
                }
                else if (this.atms[i].city === this.city) {
                    this.showAtms[j] = this.atms[i];
                    j++;
                }
            }
        }
        this.checkedType = type;
        this.showTypes = false;
    }
    clickLocation(atm, index) {
        this.setActive(1);
        if (screen.height < 960) {
            this.myScrollContainer.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        this.zoom = 8;
        this.longitude = parseInt(atm.longitudes) + 0.7;
        this.latitude = parseInt(atm.latitude) + 0.4;
    }
};
CryptoAtmsComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: WebClientService },
    { type: DomSanitizer },
    { type: WebsiteThemeService }
];
__decorate([
    ViewChild('AgmMap')
], CryptoAtmsComponent.prototype, "agmMap", void 0);
__decorate([
    ViewChild('scrollMe')
], CryptoAtmsComponent.prototype, "myScrollContainer", void 0);
__decorate([
    HostListener('document:click', ['$event'])
], CryptoAtmsComponent.prototype, "onDocumentClick", null);
CryptoAtmsComponent = __decorate([
    Component({
        selector: 'ecd-atms',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./crypto-atms.component.html")).default
    })
], CryptoAtmsComponent);
export { CryptoAtmsComponent };
